<template>
    <li class="sportsSwitch-sportItem sportsSwitch-multipleSportsZone">
        <div
            class="sportsSwitch-multipleSportsZone-background SportList_Btn_Olympic2024"
        >
            <SboIcon
                class="sportsSwitch-multipleSportsZone-icon"
                name="sports:othrsColor"
                v-bind:size="28"
            />
            <span class="sportsSwitch-multipleSportsZone-title">{{ i18n.t('multipleSports_title') }}</span>
            <img
                class="sportsSwitch-multipleSportsZone-arrow"
                src="@/assets/images/multiple-sports/arrow-forward.svg"
                alt=""
                aria-hidden="true"
            >
        </div>
    </li>
</template>

<script lang="ts" setup>
    import SboIcon from '@/components/common/SboIcon.vue';
    import { i18n } from '@/libraries/i18n';
</script>

<style lang="scss" scoped>
.sportsSwitch-multipleSportsZone {
    font-weight: $fontWeight-bold;

    &-background {
        display: flex;
        width: calc(100% - 3px);
        height: 36px;
        align-items: center;
        padding: $space-none $space-md $space-none $space-sm;
        background-image: url("@/assets/images/multiple-sports/BgFlagBannerAsianGames2026.png");
        background-image:
            image-set(
                url("@/assets/images/multiple-sports/BgFlagBannerAsianGames2026.webp") type("image/webp"),
                url("@/assets/images/multiple-sports/BgFlagBannerAsianGames2026.png") type("image/png")
            );
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        border-radius: $borderRadius-md;
        box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 25%);
        color: $white;
    }

    &-title {
        overflow: hidden;
        min-width: 0;
        flex: 1;
        text-overflow: ellipsis;
        white-space: nowrap;

        &:lang(my) {
            line-height: 1.8;
        }
    }

    &-arrow {
        display: flex;
        height: 2rem;
        align-items: center;
        margin-left: $space-sm;
        animation-direction: alternate;
        animation-duration: 0.5s;
        animation-iteration-count: infinite;
        animation-name: move;
        animation-timing-function: linear;
    }

    &-icon.svgIcon {
        margin-right: $space-sm;
        fill: initial;
    }

    @keyframes move {
        from {
            transform: translateX(0%);
        }

        to {
            transform: translateX(-50%);
        }
    }
}
</style>
